import { render } from "./1WhatWeDoToSharks.vue?vue&type=template&id=5d54062d&scoped=true"
import script from "./1WhatWeDoToSharks.vue?vue&type=script&lang=js"
export * from "./1WhatWeDoToSharks.vue?vue&type=script&lang=js"

import "./1WhatWeDoToSharks.vue?vue&type=style&index=0&id=5d54062d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d54062d"

export default script